import React, { useState } from "react";
import { FormControl, Input, InputAdornment, IconButton, FormHelperText } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";

const PasswordField = ({
  label,
  required,
  value,
  onChange,
  error,
  helperText,
  style,
}) => {
  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        width: "100%",
      }}
    >
      <div
        style={{
          display: "flex",
          textAlign: "start",
          marginTop: "10px",
          fontSize: "18px",
          fontWeight: "400",
          color: style?.color,
        }}
      >
        <label>
          {label}
          {required && (
            <span
              className="mandatory"
              style={{ color: "red", marginLeft: "5px" }}
            >
              *
            </span>
          )}
        </label>
      </div>
      <FormControl style={style} variant="standard" error={error} fullWidth>
        <Input
          type={showPassword ? "text" : "password"} // Toggle between text and password
          value={value}
          onChange={onChange}
          style={{ color: style?.color, width: style?.width }}
          endAdornment={
            <InputAdornment position="end">
              <IconButton onClick={togglePasswordVisibility} edge="end">
                {showPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
          }
        />
        {helperText && <FormHelperText>{helperText}</FormHelperText>}
      </FormControl>
    </div>
  );
};

export default PasswordField;